module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"internal":"Intern","notes":"Notizen"},"en":{"internal":"Internal","notes":"Notes"}}')
  delete Component.options._Ctor
}
